import {
  CourseFindById,
  courseCategoryList,
  terminalList,
  priorityList,
  courseSetBasicInformation,
  CourseTerminalListByCourse,
} from './Request';

/**
 * La regla de vigencia viaja como cadena JSON: el esquema GraphQL la declara
 * `String`. Una regla corrupta se trata como ausente en vez de reventar la
 * pantalla de definición.
 */
export const parseVigency = rule => {
  if (!rule) return null;
  if (typeof rule === 'object') return rule;

  try {
    return JSON.parse(rule);
  } catch {
    return null;
  }
};

export const serializeVigency = rule => (rule ? JSON.stringify(rule) : null);

const mapCourse = course => ({
  id: course.id,
  name: course.name,
  category: course?.CourseCategory?.id ?? '',
  description: course?.description ?? '',
  trainingHours: course?.trainingHours ?? 0,
  priority: course?.Priority?.id ?? '',
  expirationRule: parseVigency(course?.expirationRule),
  dueAmount: course?.dueAmount ?? null,
  dueUnit: course?.dueUnit ?? null,
  thumbnail: course?.thumbnail ?? '',
});

export const fetchCourse = async ({ id = '' }) => {
  const courseObject = await CourseFindById({
    id,
  });

  // Mismo caso que en `courseIsValid`: sin curso no hay nada que mapear.
  if (!courseObject) return null;

  const mappedObject = mapCourse(courseObject);

  const courseTerminals = await CourseTerminalListByCourse({
    courseId: mappedObject.id,
  });

  const mappedTerminals = courseTerminals.map(terminal => ({
    courseTerminalId: terminal.id,
    id: terminal.terminalId,
    name: terminal.Terminal.name,
  }));

  return { ...mappedObject, terminals: mappedTerminals };
};

export const fetchOptionsInformation = async () => {
  const promises = [];
  promises.push(courseCategoryList());
  promises.push(terminalList());
  promises.push(priorityList());

  const data = await Promise.all(promises);
  const categories = data[0];
  const terminals = data[1];
  const priorities = data[2];

  return { categories, terminals, priorities };
};

export const setCourseBasicInformation = async courseData =>
  courseSetBasicInformation({
    ...courseData,
    expirationRule: serializeVigency(courseData?.expirationRule),
    dueAmount: courseData?.dueAmount ?? null,
    dueUnit: courseData?.dueUnit ?? null,
  });

export default {
  fetchCourse,
  fetchOptionsInformation,
  setCourseBasicInformation,
};
